module.exports = __webpack_public_path__ + "media/images/icons/icon-x-cs-dce4e5c4ebb5f4f98d53324b09bbb38a.svg";